var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 376,
    viewBox: "0 0 396 376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3853_32128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.777 313.132H56.522L43.7247 314.938V319.575C43.7247 325.166 48.3939 329.695 54.1513 329.695H360.853C366.61 329.695 371.279 325.166 371.279 319.575V315.868L366.777 313.132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.279 315.452H43.7247V80.211C43.7247 74.6703 48.2178 70.1772 53.7585 70.1772H361.241C366.782 70.1772 371.275 74.6703 371.275 80.211V315.452H371.279Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9531 81.3625C55.3797 81.3625 54.9146 81.8277 54.9146 82.4011V304.263H360.09V81.3625H55.9531Z",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.279 319.273C371.279 325.03 366.61 329.699 360.853 329.699H54.1513C48.3939 329.699 43.7247 325.03 43.7247 319.273",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.786 361.345H156.218C151.522 361.345 147.711 357.538 147.711 352.837V329.695H267.289V352.837C267.289 357.534 263.482 361.345 258.781 361.345H258.786Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.167 337.132H262.836",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.414 249.723H0.451538V375.248H164.414V249.723Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.163 304.263H93.9115",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.054 0.45166H288.521V137.514H395.054V0.45166Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.213 33.4789V10.7969H348.53V12.0296H336.672V21.4899H347.559V22.7543H336.672V32.2461H348.53V33.4789H335.213Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.332 64.0903V42.4333H333.831V43.6074H322.723V52.6116H332.531V53.7856H322.723V64.0858H321.332V64.0903Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.789 64.0903V42.4333H356.102C357.773 42.4333 359.137 42.6953 360.202 43.2236C361.264 43.7474 362.045 44.4654 362.537 45.373C363.034 46.2807 363.278 47.3238 363.278 48.4978C363.278 49.6719 363.029 50.7195 362.537 51.6362C362.04 52.5529 361.268 53.2709 360.216 53.7856C359.164 54.3004 357.791 54.5578 356.102 54.5578H351.185V64.0858H349.794L349.789 64.0903ZM351.18 53.3566H356.129C358.048 53.3566 359.475 52.9457 360.415 52.1194C361.354 51.293 361.824 50.0873 361.824 48.4978C361.824 46.9083 361.354 45.7027 360.415 44.8763C359.475 44.0499 358.048 43.639 356.129 43.639H351.18V53.3521V53.3566Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.399 86.5103V72.7692H312.996V71.979H322.709V72.7692H318.329V86.5103H317.394H317.399Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.706 86.7587C340.325 86.7587 339.11 86.4426 338.076 85.8149C337.037 85.1873 336.229 84.3067 335.647 83.1778C335.064 82.0489 334.775 80.7394 334.775 79.2447C334.775 77.75 335.064 76.4586 335.647 75.3297C336.229 74.2008 337.037 73.3202 338.076 72.6835C339.115 72.0468 340.325 71.7307 341.706 71.7307C343.088 71.7307 344.348 72.0513 345.391 72.6835C346.434 73.3202 347.243 74.2008 347.812 75.3297C348.381 76.4586 348.661 77.7636 348.661 79.2447C348.661 80.7258 348.376 82.0489 347.812 83.1778C347.243 84.3067 346.439 85.1828 345.391 85.8149C344.348 86.4471 343.12 86.7587 341.706 86.7587ZM341.729 85.9098C342.876 85.9098 343.901 85.6479 344.8 85.1195C345.698 84.5957 346.403 83.8326 346.918 82.8346C347.428 81.8367 347.685 80.64 347.685 79.2447C347.685 77.8494 347.428 76.6482 346.918 75.6548C346.407 74.6568 345.698 73.8982 344.8 73.3699C343.901 72.8461 342.876 72.5796 341.729 72.5796C340.582 72.5796 339.557 72.8416 338.658 73.3699C337.76 73.8982 337.051 74.6568 336.532 75.6548C336.012 76.6527 335.755 77.8494 335.755 79.2447C335.755 80.64 336.012 81.8412 336.532 82.8346C337.051 83.8326 337.76 84.5912 338.658 85.1195C339.557 85.6479 340.582 85.9098 341.729 85.9098Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.988 86.5103V85.7426L368.647 72.8099H361.155V71.979H369.748V72.7692L362.09 85.6614H369.893V86.5103H360.988Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.255 95.4692H312.35V105.277H321.255V95.4692Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.773 95.4692H328.869V105.277H337.773V95.4692Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.292 95.4692H345.387V105.277H354.292V95.4692Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.81 95.4692H361.905V105.277H370.81V95.4692Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.837 119.176H312.35V125.218H317.837V119.176Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.512 119.176H323.025V125.218H328.512V119.176Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.191 119.176H333.705V125.218H339.191V119.176Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.871 119.176H344.384V125.218H349.871V119.176Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.546 119.176H355.059V125.218H360.546V119.176Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.225 119.176H365.739V125.218H371.225V119.176Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.35 112.602H370.814",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.062 218.981L177.803 218.507L181.217 99.1631H235.648L239.062 218.981Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.038 199.22H139.867V304.263H275.038V199.22Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.163 304.263H187.751V210.487L181.217 99.1631C181.217 99.1631 163.795 100.504 147.101 105.747C126.794 112.127 111.003 128.212 104.799 148.573C99.9759 164.405 94.5662 186.333 91.5678 212.158C88.7501 236.416 107.747 257.702 132.168 257.702V304.263H132.163Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.53 304.263H228.942V210.487L235.476 99.1632C235.476 99.1632 242.214 99.118 247.619 99.8315C272.834 103.164 294.613 119.091 305.622 142.016C312.472 156.29 323.016 183.032 331.203 211.973C335.976 228.847 331.357 246.987 319.137 259.563L308.368 270.73L303.987 265.659L284.534 274.126V304.258L284.53 304.263Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.761 234.677C281.761 234.677 294.17 250.604 305.243 266.95C305.243 266.95 285.573 279.427 282.204 280.334C279.183 281.152 257.689 273.417 248.707 271.254C247.267 270.906 246.318 269.538 246.508 268.066L246.648 266.973L242.841 266.521C241.36 266.345 240.245 265.085 240.245 263.595V263.369C240.245 262.042 241.22 260.917 242.53 260.723L246.652 260.109L237.084 258.7C235.67 258.492 234.528 257.436 234.203 256.045C233.882 254.65 234.731 253.254 236.122 252.907C239.351 252.107 244.9 250.861 247.732 250.996C247.732 250.996 235.639 250.893 234.98 249.714C234.009 247.976 235.607 244.327 247.714 243.817C259.82 243.311 266.395 246.865 266.395 246.865L281.757 234.668L281.761 234.677Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.47 260.145C249.091 260.254 250.712 260.362 252.333 260.47",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.517 266.955C250.057 267.122 253.588 267.537 257.07 268.196",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.474 184.283L284.214 222.959",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.761 234.677L277.286 229.082L299.111 209.787",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.17 106.691H192.637L193.675 70.665H224.607L226.17 106.691Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.056 55.2758C189.056 58.9334 191.598 64.9934 187.967 65.445C180.065 66.4204 175.807 58.938 175.807 55.2758C175.807 51.6136 178.774 48.6514 182.431 48.6514C186.089 48.6514 189.056 51.6181 189.056 55.2758Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.036 56.6169C183.84 57.9129 186.252 60.0398 187.886 62.6588",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.322 55.2758C229.322 58.9334 226.779 64.9934 230.41 65.445C238.312 66.4204 242.57 58.938 242.57 55.2758C242.57 51.6136 239.604 48.6514 235.946 48.6514C232.288 48.6514 229.322 51.6181 229.322 55.2758Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.341 56.6169C234.537 57.9129 232.126 60.0398 230.491 62.6588",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.08 85.5936H201.293C194.637 85.5936 189.132 80.4142 188.722 73.7717L185.94 28.498H232.433L229.651 73.7717C229.245 80.4142 223.736 85.5936 217.08 85.5936Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.024 54.3094C187.511 54.0655 190.46 53.3205 190.406 48.2133C190.406 48.2133 208.586 46.1226 217.4 30.363C217.4 30.363 222.273 44.0815 228.766 47.3508C228.766 47.3508 229.042 53.5011 230.884 53.7449L233.918 48.5791C233.918 48.5791 235.463 25.7119 235.512 20.6589C235.562 15.6014 228.766 10.2369 221.875 14.8338C221.875 14.8338 204.282 4.51558 191.458 11.9348C178.634 19.3539 175.288 34.5264 185.312 45.4813L187.028 54.3049L187.024 54.3094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.806 216.642L213.35 125.259L220.71 109.978L208.762 102.758L196.809 109.978L204.17 125.259L192.713 216.642H224.806Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.502 91.0442L208.762 97.7499L190.018 91.0442L187.295 99.2897V108.213L199.546 119.727L208.762 109.197L217.974 119.727L230.225 108.213V99.2897L227.502 91.0442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.225 99.2897L227.502 91.0442L208.762 97.7499L190.018 91.0442L187.295 99.2897",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.295 99.2896L199.546 119.727L208.762 109.197L217.974 119.727L230.225 99.2896",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.175 266.955H155.965L146.252 161.33H229.462L239.175 266.955Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.254 202.846H194.809C201.004 203.411 207.136 201.135 211.539 196.583C215.558 192.429 218.814 190.695 220.891 191.192C224.801 192.126 216.023 208.351 216.023 208.351H234.153C237.63 208.351 240.01 212.085 238.542 215.35C238.24 216.023 237.879 216.66 237.454 217.206C237.454 217.206 240.078 218.746 237.454 223.835C237.454 223.835 239.229 227.186 236.93 231.62C236.93 231.62 239.346 233.571 236.93 237.052C234.515 240.529 225.474 245.081 211.291 245.496C207.841 245.596 185.037 248.626 185.037 248.626V257.314H134.141L123.263 202.842L123.254 202.846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.254 202.846H194.809C201.004 203.411 207.136 201.135 211.539 196.583C215.558 192.429 218.814 190.695 220.891 191.192C224.801 192.126 216.023 208.351 216.023 208.351H234.153C237.63 208.351 240.01 212.085 238.542 215.35C238.24 216.023 237.879 216.66 237.454 217.206C237.454 217.206 240.078 218.746 237.454 223.835C237.454 223.835 239.229 227.186 236.93 231.62C236.93 231.62 239.346 233.571 236.93 237.052C234.515 240.529 225.474 245.081 211.291 245.496C207.841 245.596 185.037 248.626 185.037 248.626V257.314H133.288",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.434 221.943C225.434 221.943 232.528 220.602 237.445 217.206",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.445 223.84C237.445 223.84 232.153 227.29 225.434 229.168",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.921 231.625C236.921 231.625 233.467 234.375 225.434 237.057",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.082 243.894V202.025",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.121 339.855L109.463 320.004C104.297 316.297 97.104 317.476 93.3922 322.646C89.6849 327.812 90.8634 335.005 96.0338 338.717L123.692 358.568C128.858 362.275 136.051 361.097 139.763 355.926C143.47 350.76 142.292 343.567 137.121 339.855Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.295 329.93L109.861 348.638",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4959 198.561C67.7163 197.911 65.0566 194.118 65.0792 189.932L65.1244 181.619C65.1244 181.619 65.1244 181.578 65.1244 181.555C65.1244 178.403 62.6633 175.911 59.7824 175.897L53.4199 175.861C50.5389 175.848 48.0553 178.313 48.0192 181.461C48.0192 181.483 48.0192 181.501 48.0192 181.524L47.974 189.837C47.9514 194.023 45.2556 197.789 41.467 198.399C37.5429 199.031 34.6439 202.698 34.6213 207.019L34.4723 235.625L78.1023 235.865L78.2513 207.258C78.2739 202.941 75.4109 199.239 71.4959 198.566V198.561Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8041 230.803L31.8781 230.538C29.267 230.524 27.1388 232.629 27.1247 235.24L27.0945 240.817C27.0804 243.428 29.1856 245.556 31.7967 245.57L80.7228 245.835C83.3339 245.849 85.4621 243.744 85.4762 241.133L85.5064 235.556C85.5205 232.945 83.4152 230.817 80.8041 230.803Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5891 360.948L25.73 360.622C21.7653 360.6 18.5682 357.371 18.5863 353.402L19.1236 249.321C19.1462 245.352 22.3794 242.155 26.3441 242.178L86.2032 242.503C90.1679 242.525 93.365 245.754 93.347 249.723L92.8051 353.804C92.7825 357.773 89.5493 360.97 85.5846 360.948H85.5891Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6011 288.806H86.4968V349.464C86.4968 352.264 84.2209 354.54 81.4212 354.54H29.5863C26.8363 354.54 24.6056 352.309 24.6056 349.559V288.806H24.6011Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4803 337.719V337.101C61.4803 334.992 62.1441 332.924 63.3859 331.14C64.6277 329.356 65.2915 327.288 65.2915 325.179L65.3366 242.34H48.1592L48.114 325.184C48.114 327.293 48.7733 329.361 50.0151 331.14C51.2569 332.924 51.9162 334.987 51.9162 337.096V337.715C51.9162 340.108 54.0566 342.05 56.6982 342.05C59.3399 342.05 61.4848 340.108 61.4848 337.71L61.4803 337.719Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.517 337.692H82.4733C76.1153 337.692 70.9585 342.849 70.9585 349.207C70.9585 355.565 76.1153 360.722 82.4733 360.722H116.517C122.875 360.722 128.031 355.565 128.031 349.207C128.031 342.849 122.875 337.692 116.517 337.692Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4928 337.692V360.726",
    stroke: "black",
    strokeWidth: 0.903125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3853_32128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 395.501,
    height: 375.7,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessUser);
export default __webpack_public_path__ + "static/media/BusinessUser.4d296231a99050e02458cd9bd311e672.svg";
export { ForwardRef as ReactComponent };